(function () {
  if (customElements.get('navaratri-slider')) return;
  class NavaratriSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nvs__track');
      this.cards = Array.from(this.querySelectorAll('.nvs__card'));
      this.dots = Array.from(this.querySelectorAll('.nvs__dot'));
      this.sr = this.querySelector('.nvs__sr');
      if (!this.track || !this.cards.length) return;
      this.target = null;
      var self = this;

      this.querySelectorAll('[data-direction]').forEach(function (b) {
        b.addEventListener('click', function () { self.move(b.dataset.direction); });
      });
      this.dots.forEach(function (d) {
        d.addEventListener('click', function () { self.goTo(parseInt(d.dataset.index, 10)); });
      });

      this.onScroll = function () {
        if (self.raf) return;
        self.raf = requestAnimationFrame(function () { self.raf = null; self.update(); });
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.onKey = function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          self.move(e.key === 'ArrowRight' ? 'next' : 'previous');
        }
      };
      this.track.addEventListener('keydown', this.onKey);

      this.onPointer = function () { self.target = null; };
      this.track.addEventListener('pointerdown', this.onPointer, { passive: true });
      this.track.addEventListener('wheel', this.onPointer, { passive: true });

      this.onResize = function () { self.target = null; self.update(); };
      window.addEventListener('resize', this.onResize, { passive: true });

      this.update();
    }
    disconnectedCallback() {
      if (this.track) {
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('keydown', this.onKey);
        this.track.removeEventListener('pointerdown', this.onPointer);
        this.track.removeEventListener('wheel', this.onPointer);
      }
      window.removeEventListener('resize', this.onResize);
    }
    step() {
      var gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      return this.cards[0].getBoundingClientRect().width + gap;
    }
    perView() {
      var s = this.step();
      if (!s) return 1;
      return Math.max(1, Math.round(this.track.clientWidth / s));
    }
    maxIndex() {
      return Math.max(0, this.cards.length - this.perView());
    }
    index() {
      var s = this.step();
      if (!s) return 0;
      return Math.max(0, Math.min(this.maxIndex(), Math.round(this.track.scrollLeft / s)));
    }
    goTo(target) {
      var max = this.maxIndex();
      var next = Math.max(0, Math.min(max, target));
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.target = next;
      this.track.scrollTo({ left: next * this.step(), behavior: smooth ? 'smooth' : 'auto' });
      this.paint(next, max);
    }
    move(dir) {
      var base = this.target === null ? this.index() : this.target;
      this.goTo(base + (dir === 'next' ? 1 : -1));
    }
    paint(current, max) {
      this.dots.forEach(function (d, i) {
        d.style.display = i > max ? 'none' : '';
        if (i === current) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      this.querySelectorAll('[data-direction]').forEach(function (b) {
        var end = b.dataset.direction === 'next' ? current >= max : current <= 0;
        b.disabled = end;
        b.style.opacity = end ? '.35' : '';
      });
      if (this.sr) this.sr.textContent = (current + 1) + ' / ' + (max + 1);
    }
    update() {
      var max = this.maxIndex();
      var current = this.index();
      if (this.target !== null) {
        if (Math.abs(this.track.scrollLeft - this.target * this.step()) < 6) this.target = null;
        else current = this.target;
      }
      this.paint(current, max);
    }
  }
  customElements.define('navaratri-slider', NavaratriSlider);
})();